import { todayParis } from "../utils/calendar.mjs";
import { shiftDate } from "../dashboard-metrics.mjs";
import { unpaidInvoiceTasks } from "./unpaid-invoices.mjs";
export function agencyMetrics(state, filters, now = new Date()) {
  const clients = state.clients.filter(
    (c) =>
      (!filters.owner || c.ownerId === filters.owner) &&
      (!filters.agency || c.agency === filters.agency),
  );
  const ids = new Set(clients.map((c) => c.id));
  const today = todayParis(now),
    nextWeek = shiftDate(today, 7);
  const needs = state.needs.filter((n) => ids.has(n.clientId));
  const active = needs.filter((n) => !["perdu", "suspendu"].includes(n.status));
  const open = active.filter((n) => n.status !== "signé");
  const starts = active
    .filter((n) => n.start && n.start <= nextWeek)
    .sort((a, b) => a.start.localeCompare(b.start));
  const handoffs = (state.recruitmentNeeds || []).filter(
    (n) => ids.has(n.clientId) || needs.some((x) => x.id === n.needId),
  );
  const missing = handoffs.filter((n) => n.missingFields?.length);
  const signedPending = needs.filter(
    (n) => n.status === "signé" && !n.transmittedAt,
  );
  const orders = clients.flatMap((c) =>
    (c.orders || [])
      .filter((o) => o.date >= filters.from && o.date <= filters.to)
      .map((o) => ({ ...o, clientId: c.id, client: c.name, owner: c.owner })),
  );
  const known = (value) =>
    value !== null &&
    value !== undefined &&
    value !== "" &&
    Number.isFinite(Number(value));
  const ca = orders.filter((o) => known(o.amount)),
    margins = orders.filter((o) => known(o.margin));
  const invoices = unpaidInvoiceTasks({ ...state, clients }, today);
  const types = ["Intérim", "Vacation", "CDD", "CDI"].map((type) => ({
    type,
    needs: active.filter((n) => n.type === type).length,
    positions: active
      .filter((n) => n.type === type)
      .reduce((sum, n) => sum + (Number(n.qty) || 0), 0),
  }));
  return {
    clients,
    needs,
    active,
    open,
    starts,
    handoffs,
    missing,
    signedPending,
    orders,
    invoices,
    types,
    ca: ca.reduce((s, o) => s + Number(o.amount), 0),
    margin: margins.reduce((s, o) => s + Number(o.margin), 0),
    caCoverage: ca.length,
    marginCoverage: margins.length,
    unpaid: invoices.reduce((s, t) => s + t.remainingAmount, 0),
    today,
  };
}
